import React from 'react';
import { Typography } from '@/components/Typography/Typography';
import { Container } from '@/components/Containers/Container';

export const EnsuringDataPrivacy = () => {
  return (
    <section className="relative">
      <Container className="md:py-24.5-vw py-15">
        <div className="relative">
          <div className="z-10 flex flex-col justify-center items-center lg:gap-7.5-vw gap-6 relative">
            <div className="flex flex-col lg:gap-7.5-vw gap-7 items-center w-full z-10 md:pt-7.5-vw max-md:px-4">
              <div className="w-full justify-center">
                <Typography
                  as="h2"
                  $weight="700"
                  $type="Heading1"
                  className="font-formula text-center"
                >
                  Ensuring Data Privacy
                </Typography>
              </div>
              <div className="flex relative items-stretch h-full max-lg:flex-col w-full md:gap-6-vw gap-6">
                <div className="flex w-full items-center md:gap-4-vw gap-4 border md:rounded-md-10-vw rounded-md-10 lg:px-6-vw lg:py-12.5-vw py-7.5 px-7.5">
                  <svg
                    className="lg:min-w-[4.167vw] lg:min-h-[4.167vw] min-w-15 min-h-15 lg:max-w-[4.167vw] lg:max-h-[4.167vw] max-w-15 max-h-15"
                    xmlns="http://www.w3.org/2000/svg"
                    width="60"
                    height="60"
                    viewBox="0 0 60 60"
                    fill="none"
                  >
                    <rect width="60" height="60" rx="5" fill="#F1F7F6" />
                    <path
                      d="M26.8681 26.689C29.9179 26.689 32.3881 24.207 32.3881 21.1426C32.3881 18.0782 29.9179 15.5962 26.8681 15.5962C23.8183 15.5962 21.3481 18.0782 21.3481 21.1426C21.3481 24.207 23.8183 26.689 26.8681 26.689ZM26.8681 18.3694C27.6001 18.3694 28.3021 18.6616 28.8197 19.1816C29.3373 19.7017 29.6281 20.4071 29.6281 21.1426C29.6281 21.8781 29.3373 22.5835 28.8197 23.1035C28.3021 23.6236 27.6001 23.9158 26.8681 23.9158C25.3363 23.9158 24.1081 22.6817 24.1081 21.1426C24.1081 19.6035 25.3501 18.3694 26.8681 18.3694ZM29.6281 37.7818H15.8281V33.622C15.8281 29.9198 23.1835 28.0756 26.8681 28.0756C28.2481 28.0756 30.1525 28.3391 31.9879 28.8521C31.5739 29.6286 31.3255 30.4883 31.2979 31.3896C29.9455 30.9875 28.3999 30.7102 26.8681 30.7102C22.7695 30.7102 18.4501 32.7346 18.4501 33.622V35.1473H29.6281V35.2859V37.7818ZM41.7721 33.622V31.5421C41.7721 29.6009 39.8401 28.0756 37.9081 28.0756C35.9761 28.0756 34.0441 29.6009 34.0441 31.5421V33.622C33.2161 33.622 32.3881 34.454 32.3881 35.2859V41.3936C32.3881 42.3642 33.2161 43.1962 34.0441 43.1962H41.6341C42.6001 43.1962 43.4281 42.3642 43.4281 41.5323V35.4246C43.4281 34.454 42.6001 33.622 41.7721 33.622ZM39.9781 33.622H35.8381V31.5421C35.8381 30.4328 36.8041 29.7395 37.9081 29.7395C39.0121 29.7395 39.9781 30.4328 39.9781 31.5421V33.622Z"
                      fill="#05050D"
                    />
                  </svg>
                  <Typography $type="PMedium">
                    <b>
                      <i>All data is anonymized within the system,</i>
                    </b>{' '}
                    designed with a specific architecture for data security to protect sensitive
                    customer information.
                  </Typography>
                </div>
                <div className="flex w-full items-center md:gap-4-vw gap-4 border md:rounded-md-10-vw rounded-md-10 lg:px-6-vw lg:py-12.5-vw py-7.5 px-7.5">
                  <svg
                    className="lg:min-w-[4.167vw] lg:min-h-[4.167vw] min-w-15 min-h-15 lg:max-w-[4.167vw] lg:max-h-[4.167vw] max-w-15 max-h-15"
                    width="60"
                    height="60"
                    viewBox="0 0 60 60"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <rect width="60" height="60" rx="5" fill="#F1F7F6" />
                    <g clipPath="url(#clip0_11749_22242)">
                      <path
                        d="M29.4602 32.1293C29.9974 32.1293 30.5294 32.0234 31.0257 31.8179C31.5221 31.6123 31.9731 31.3109 32.3529 30.9311C32.7328 30.5512 33.0341 30.1002 33.2397 29.6039C33.4453 29.1075 33.5511 28.5756 33.5511 28.0383M29.4602 32.1293C28.3752 32.1293 27.3347 31.6983 26.5675 30.9311C25.8003 30.1639 25.3693 29.1233 25.3693 28.0383M29.4602 32.1293V36.2202M33.5511 28.0383C33.5511 27.5011 33.4453 26.9692 33.2397 26.4728C33.0341 25.9765 32.7328 25.5255 32.3529 25.1456C31.9731 24.7658 31.5221 24.4644 31.0257 24.2588C30.5294 24.0533 29.9974 23.9474 29.4602 23.9474M33.5511 28.0383H37.642M29.4602 23.9474C28.3752 23.9474 27.3347 24.3784 26.5675 25.1456C25.8003 25.9128 25.3693 26.9534 25.3693 28.0383M29.4602 23.9474V19.8565M25.3693 28.0383H21.2784M24.0057 22.5838L26.7329 25.3111M32.1875 30.7656L34.9148 33.4929M34.9148 22.5838L32.1875 25.3111M26.7329 30.7656L24.0057 33.4929M29.4602 43.0383C29.4602 43.0383 17.1875 37.5838 17.1875 28.0383V19.8565L29.4602 15.7656L41.7329 19.8565V28.0383C41.7329 37.5838 29.4602 43.0383 29.4602 43.0383Z"
                        stroke="#05050D"
                        strokeWidth="2.3"
                      />
                    </g>
                    <defs>
                      <clipPath id="clip0_11749_22242">
                        <rect
                          width="27.2727"
                          height="30"
                          fill="white"
                          transform="translate(15.8203 14.4023)"
                        />
                      </clipPath>
                    </defs>
                  </svg>

                  <Typography $type="PMedium">
                    <b>
                      <i>The server infrastructure is owned by CoSupport AI,</i>
                    </b>{' '}
                    further enhancing data protection measures.
                  </Typography>
                </div>
                <div className="flex w-full items-center md:gap-4-vw gap-4 border md:rounded-md-10-vw rounded-md-10 lg:px-6-vw lg:py-12.5-vw py-7.5 px-7.5">
                  <svg
                    className="lg:min-w-[4.167vw] lg:min-h-[4.167vw] min-w-15 min-h-15 lg:max-w-[4.167vw] lg:max-h-[4.167vw] max-w-15 max-h-15"
                    width="60"
                    height="60"
                    viewBox="0 0 60 60"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <rect width="60" height="60" rx="5" fill="#F1F7F6" />
                    <g clipPath="url(#clip0_11749_22248)">
                      <path
                        d="M29.2143 43.0968C30.6213 43.0968 32.0145 42.8197 33.3144 42.2813C34.6144 41.7428 35.7955 40.9536 36.7904 39.9587C37.7853 38.9638 38.5745 37.7827 39.113 36.4827C39.6514 35.1828 39.9285 33.7896 39.9285 32.3826V26.4254C39.9287 23.7933 38.96 21.2533 37.2071 19.2897M18.5 28.804V32.3826C18.4993 34.4918 19.1211 36.5542 20.2876 38.3115C21.454 40.0688 23.1132 41.4428 25.0571 42.2611M34.5714 17.1468C32.1106 15.7261 29.1861 15.3411 26.4414 16.0765C23.6967 16.8119 21.3566 18.6075 19.9357 21.0683C19.3507 22.0787 18.9379 23.1795 18.7143 24.3254"
                        stroke="#05050D"
                        strokeWidth="2.3"
                      />
                      <path
                        d="M28.1029 21.9258C28.891 21.7621 29.7059 21.7775 30.4873 21.9707C31.2687 22.1639 31.9968 22.5301 32.6178 23.0421C33.2389 23.5542 33.7371 24.1992 34.0757 24.9294C34.4143 25.6597 34.5847 26.4566 34.5743 27.2615V30.7115M33.2029 35.2115C32.4738 36.0236 31.514 36.5937 30.4521 36.8454C29.3901 37.0971 28.2765 37.0185 27.2605 36.62C26.2444 36.2215 25.3743 35.5222 24.7666 34.6156C24.1589 33.709 23.8426 32.6385 23.8601 31.5472V27.2615C23.856 26.5255 24.0018 25.7964 24.2886 25.1186M29.2172 27.4972V31.0758"
                        stroke="#05050D"
                        strokeWidth="2.3"
                        strokeLinejoin="round"
                      />
                    </g>
                    <defs>
                      <clipPath id="clip0_11749_22248">
                        <rect
                          width="24.5454"
                          height="30"
                          fill="white"
                          transform="translate(16.9453 14.4043)"
                        />
                      </clipPath>
                    </defs>
                  </svg>
                  <Typography $type="PMedium">
                    <b>
                      <i>Data storage on dedicated servers</i>
                    </b>{' '}
                    guarantees the highest level of security: "1 client = 1 dedicated server"
                  </Typography>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Container>
    </section>
  );
};
